export default __webpack_public_path__ + "static/media/3092.38c305db.jpg";